export const VALIDATION_FAILED_MESSAGE = 'Validation failed';
export const VALIDATION_SUCCESS_MESSAGE = 'Validation success';

/**
 * Error codes for all public HTTP requests
 */
export const IkeRouteErrorCode = {
	VALID: 'valid' as const,
	UNAUTHORIZED: 'unauthorized' as const,
	INVALID: 'invalid' as const,
	MISSING: 'missing' as const,
	MISSING_FIELD: 'missing_field' as const,
	ALREADY_EXISTS: 'already_exists' as const,
	UNSUPPORTED: 'unsupported' as const,
	NOT_FOUND: 'not_found' as const,
	LICENSE_REQUIRED: 'license_required' as const,
};

export type IkeRouteErrorCode =
	| typeof IkeRouteErrorCode.VALID
	| typeof IkeRouteErrorCode.UNAUTHORIZED
	| typeof IkeRouteErrorCode.INVALID
	| typeof IkeRouteErrorCode.MISSING
	| typeof IkeRouteErrorCode.MISSING_FIELD
	| typeof IkeRouteErrorCode.ALREADY_EXISTS
	| typeof IkeRouteErrorCode.UNSUPPORTED
	| typeof IkeRouteErrorCode.NOT_FOUND
	| typeof IkeRouteErrorCode.LICENSE_REQUIRED;

export interface IkeRouteFieldMessage {
	field: string;
	codes: string;
	message?: string;
}

export interface IkeRouteValidationResponse {
	message: string;
	errors?: IkeRouteFieldMessage[];
	warnings?: IkeRouteFieldMessage[];
	info?: IkeRouteFieldMessage[];
}

/** Common HTTP status codes */
export enum IkeHTTPStatus {
	SUCCESS = 200,
	CREATED = 201,
	REDIRECT_PERMANENTLY = 301,
	REDIRECT_TEMPORARILY = 302,
	NOT_MODIFIED = 304,
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	NOT_FOUND = 404,
	VALIDATION_FAILED = 422,
	SERVER_ERROR = 500,
}
